export default "<p>\n  register works!\n</p>\n"